import store from '@state/store'

const basePath = process.env.BASE_URL || '/'

export default [
  {
    path: basePath,
    name: 'home',
    component: () => lazyLoadView(import('@views/home')),
  },
  {
    path: basePath + 'dealerSignIn',
    name: 'dealerSignIn',
    beforeEnter() {
      window.open(
        'https://www.experian.com/automotive/autocheck-business#consumer?cmpid=auto_AutoCheckConsumer_web',
        '_blank'
      )
    },
  },
  {
    path: basePath + 'dispute',
    name: 'dispute',
    component: () => lazyLoadView(import('@views/contact')),
    props: { helpType: 'Vehicle history report record dispute' },
  },
  {
    path: basePath + 'contact',
    name: 'contact',
    component: () => lazyLoadView(import('@views/contact')),
    props: { helpType: null },
  },
  {
    path: basePath + 'login',
    name: 'login',
    component: () => lazyLoadView(import('@views/login')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'dashboard' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: basePath + 'checkout',
    name: 'checkout',
    component: () => lazyLoadView(import('@views/checkout')),
    meta: {
      authRequired: false,
      beforeResolve(routeTo, routeFrom, next) {
        if (
          // Redirect if cart is empty
          !store.getters['customer/hasCartProduct']
        ) {
          // Redirect to the vhr product page instead
          next({ name: 'reports-list' })
        } else {
          // Continue to the checkout page
          next()
        }
      },
    },
  },
  {
    path: basePath + 'checkout/order-confirmation',
    name: 'order-confirmation',
    component: () => lazyLoadView(import('@views/checkout-confirmation')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (
          !store.getters['customer/hasCartProduct'] &&
          store.getters['auth/loggedIn']
        ) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the checkout page
          next()
        }
      },
    },
  },
  {
    path: basePath + 'vehicle-history-reports',
    name: 'reports-list',
    component: () => lazyLoadView(import('@views/vehicle-history-reports')),
    meta: {
      authRequired: false,
    },
  },
  {
    path: basePath + 'buyback-terms',
    name: 'buyback-terms',
    component: () => lazyLoadView(import('@views/buyback-terms')),
    meta: {
      authRequired: false,
    },
  },
  {
    path: basePath + 'full-vehicle-report/:vin',
    name: 'full-vehicle-report',
    component: () => lazyLoadView(import('@views/full-vehicle-report')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ vin: route.params.vin }),
  },
  {
    path: basePath + 'sample-vehicle-history-report',
    name: 'sample-report',
    component: () =>
      lazyLoadView(import('@views/sample-vehicle-history-report')),
    meta: {
      authRequired: false,
    },
  },
  {
    path: basePath + 'update-password',
    name: 'update-password',
    component: () => lazyLoadView(import('@views/update-password')),
    meta: {
      authRequired: false,
    },
  },
  {
    path: basePath + 'patent-notice',
    name: 'patent-notice',
    component: () => lazyLoadView(import('@views/patent-notice')),
    meta: {
      authRequired: false,
    },
  },
  {
    path: basePath + 'search-by-license-plate',
    name: 'search-by-license-plate',
    component: () => lazyLoadView(import('@views/search-by-license-plate')),
    meta: {
      authRequired: false,
    },
  },
  {
    path: basePath + 'odometer-fraud',
    name: 'odometer-fraud',
    component: () => lazyLoadView(import('@views/odometer-fraud')),
    meta: {
      authRequired: false,
    },
  },
  {
    path: basePath + 'autocheck-vs-bargain',
    name: 'autocheck-vs-bargain',
    component: () =>
      lazyLoadView(import('@views/autocheck-vs-bargain-reports')),
    meta: {
      authRequired: false,
    },
  },
  {
    path: basePath + 'call-for-action',
    name: 'call-for-action',
    component: () => lazyLoadView(import('@views/call-for-action')),
    meta: {
      authRequired: false,
    },
  },
  {
    path: basePath + 'affiliate-program',
    name: 'affiliate-program',
    component: () => lazyLoadView(import('@views/affiliate-program')),
    meta: {
      authRequired: false,
    },
  },
  {
    path: basePath + 'glossary',
    name: 'glossary',
    component: () => lazyLoadView(import('@views/glossary')),
    meta: {
      authRequired: false,
    },
  },
  {
    path: basePath + 'title-brands',
    name: 'title-brands',
    component: () => lazyLoadView(import('@views/title-brands')),
    meta: {
      authRequired: false,
    },
  },
  {
    path: basePath + 'vehicle-listings',
    name: 'vehicle-listings',
    component: () => lazyLoadView(import('@views/vehicle-listings')),
    meta: {
      authRequired: false,
    },
  },
  {
    path: basePath + 'autoshoppers-guide',
    name: 'autoshoppers-guide',
    component: () => lazyLoadView(import('@views/autoshoppers-guide')),
    meta: {
      authRequired: false,
    },
  },
  {
    path: basePath + 'autocheck-vs-carfax',
    name: 'autocheck-vs-carfax',
    component: () => lazyLoadView(import('@views/autocheck-vs-carfax')),
    meta: {
      authRequired: false,
    },
  },
  {
    path: basePath + 'autocheck-score',
    name: 'autocheck-score',
    component: () => lazyLoadView(import('@views/autocheck-score')),
    meta: {
      authRequired: false,
    },
  },
  {
    path: basePath + 'secure-shopping',
    name: 'secure-shopping',
    component: () => lazyLoadView(import('@views/secure-shopping')),
    meta: {
      authRequired: false,
    },
  },
  {
    path: basePath + 'free-online-delivery',
    name: 'free-online-delivery',
    component: () => lazyLoadView(import('@views/free-online-delivery')),
    meta: {
      authRequired: false,
    },
  },
  {
    path: basePath + 'faq',
    name: 'faq',
    component: () => lazyLoadView(import('@views/faq')),
    meta: {
      authRequired: false,
    },
  },
  {
    path: basePath + 'privacy-policy',
    name: 'privacy-policy',
    component: () => lazyLoadView(import('@views/privacy-policy')),
    meta: {
      authRequired: false,
    },
  },
  {
    path: basePath + 'your-ad-choices',
    name: 'your-ad-choices',
    component: () => lazyLoadView(import('@views/your-ad-choices')),
    meta: {
      authRequired: false,
    },
  },
  {
    path: basePath + 'terms-of-use',
    name: 'terms-of-use',
    component: () => lazyLoadView(import('@views/terms-of-use')),
    meta: {
      authRequired: false,
    },
  },
  {
    path: basePath + 'subscription-benefits',
    name: 'subscription-benefits',
    component: () => lazyLoadView(import('@views/subscription-benefits')),
    meta: {
      authRequired: false,
    },
  },
  {
    path: basePath + 'my-vehicle-offers',
    name: 'my-vehicle-offers',
    component: () => lazyLoadView(import('@views/my-vehicle-offers')),
    meta: {
      authRequired: false,
    },
  },
  {
    path: basePath + 'car-advise',
    name: 'car-advise',
    component: () => lazyLoadView(import('@views/car-advise')),
    meta: {
      authRequired: false,
    },
  },
  {
    path: basePath + 'car-gurus',
    name: 'car-gurus',
    component: () => lazyLoadView(import('@views/car-gurus')),
    meta: {
      authRequired: false,
    },
  },
  {
    path: basePath + 'truecar',
    name: 'truecar',
    component: () => lazyLoadView(import('@views/true-car')),
    meta: {
      authRequired: false,
    },
  },
  {
    path: basePath + 'carscom',
    name: 'carscom',
    component: () => lazyLoadView(import('@views/cars-com')),
    meta: {
      authRequired: false,
    },
  },
  {
    path: basePath + 'preferences-updated',
    name: 'preferences-updated',
    component: () => lazyLoadView(import('@views/preferences-updated')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: basePath + 'recall-check',
    name: 'recall-check',
    component: () => lazyLoadView(import('@views/recall-check')),
    meta: {
      authRequired: false,
    },
  },
  {
    path: basePath + 'free-score',
    name: 'free-score',
    component: () => lazyLoadView(import('@views/free-score')),
    meta: {
      authRequired: false,
    },
  },
  {
    path: basePath + 'vehicle-buyback-protection',
    name: 'vehicle-buyback-protection',
    component: () => lazyLoadView(import('@views/vehicle-buyback-protection')),
    meta: {
      authRequired: false,
    },
  },
  {
    path: basePath + 'flood-risk-check',
    name: 'flood-risk',
    component: () => lazyLoadView(import('@views/flood-risk-check')),
    meta: {
      authRequired: false,
    },
  },
  {
    path: basePath + 'backed-by-experian',
    name: 'backed-by-experian',
    component: () => lazyLoadView(import('@views/backed-by-experian')),
    meta: {
      authRequired: false,
    },
  },
  {
    path: basePath + 'vin-basics',
    name: 'vin-basics',
    component: () => lazyLoadView(import('@views/vin-basics')),
    meta: {
      authRequired: false,
    },
  },
  {
    path: basePath + 'why-buy-vhr',
    name: 'why-buy-vhr',
    component: () => lazyLoadView(import('@views/why-buy-vhr')),
    meta: {
      authRequired: false,
    },
  },
  {
    path: basePath + 'dashboard',
    name: 'dashboard',
    component: () => lazyLoadView(import('@views/dashboard')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: basePath + 'dealer-sign-in',
    name: 'dealer-sign-in',
    beforeEnter() {
      window.open('https://www.autocheck.com/members/login.do', '_blank')
    },
  },
  {
    path: 'https://autocheck.carzing.com',
    name: 'vehicle-listing',
    beforeEnter() {
      window.open('https://autocheck.carzing.com/', '_self')
    },
  },
  {
    path: 'https://autocheck.carzing.com/vehicle-listing',
    name: 'see-all-cars',
    beforeEnter() {
      window.open('https://autocheck.carzing.com/vehicle-listing', '_self')
    },
  },
  {
    path: 'https://autocheck.carzing.com/find-dealership',
    name: 'find-dealership',
    beforeEnter() {
      window.open('https://autocheck.carzing.com/find-dealership', '_self')
    },
  },
  {
    path: basePath + 'profile/:email',
    name: 'username-profile',
    component: () => lazyLoadView(import('@views/profile')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store
          // Try to fetch the user's information by their email
          .dispatch('customer/fetchUser', { email: routeTo.params.email })
          .then((user) => {
            // Add the user to the route params, so that it can
            // be provided as a prop for the view component below.
            routeTo.params.user = user
            // Continue to the route.
            next()
          })
          .catch(() => {
            // If a user with the provided email could not be
            // found, redirect to the 404 page.
            next({ name: '404', params: { resource: 'User' } })
          })
      },
    },
    // Set the user from the route params, once it's set in the
    // beforeResolve route guard.
    props: (route) => ({ user: route.params.user }),
  },
  {
    path: basePath + 'logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('auth/logOut')
        next({ name: 'login' })
      },
    },
  },
  {
    path: basePath + 'logout',
    name: 'logoutAndShowMsg',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('auth/logOut')
        next({ name: 'login', query: { p: 1 } })
      },
    },
  },
  {
    path: basePath + 'logout',
    name: 'logoutAndShowSessionTimeout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('auth/logOut')
        next({ name: 'login', query: { p: 2 } })
      },
    },
  },
  {
    path: basePath + '404',
    name: '404',
    component: require('@views/_404').default,
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: basePath + '*',
    redirect: basePath + '404',
  },
]

// Lazy-loads view components, but with better UX. A loading view
// will be used if the component takes a while to load, falling
// back to a timeout view in case the page fails to load. You can
// use this component to lazy-load a route with:
//
// component: () => lazyLoadView(import('@views/my-view'))
//
// NOTE: Components loaded with this strategy DO NOT have access
// to in-component guards, such as beforeRouteEnter,
// beforeRouteUpdate, and beforeRouteLeave. You must either use
// route-level guards instead or lazy-load the component directly:
//
// component: () => import('@views/my-view')
//
function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    // A component to use while the component is loading.
    loading: require('@views/_loading').default,
    // Delay before showing the loading component.
    // Default: 200 (milliseconds).
    delay: 400,
    // A fallback component in case the timeout is exceeded
    // when loading the component.
    error: require('@views/_timeout').default,
    // Time before giving up trying to load the component.
    // Default: Infinity (milliseconds).
    timeout: 10000,
  })

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      // Transparently pass any props or children
      // to the view component.
      return h(AsyncHandler, data, children)
    },
  })
}
